import axios from 'axios';

const API_BASE_URL = 'https://gerenciamento-financeiro.azurewebsites.net/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor to add JWT token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor to handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

// Auth endpoints
export const authService = {
  login: async (nomeUsuario, senha) => {
    const response = await api.post('/Auth/login', { nomeUsuario, senha });
    return response.data;
  },
  register: async (nome, nomeUsuario, senha) => {
    const response = await api.post('/Auth/register', { nome, nomeUsuario, senha });
    return response.data;
  },
};

// User endpoints
export const userService = {
  getMe: async () => {
    const response = await api.get('/Usuarios/me');
    return response.data;
  },
  checkUsernameExists: async (nome) => {
    const response = await api.get(`/Usuarios/NomeExiste/${nome}`);
    return response.data;
  },
};

// Categories endpoints
export const categoriesService = {
  getAll: async () => {
    const response = await api.get('/Categorias');
    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`/Categorias/${id}`);
    return response.data;
  },
  create: async (nome) => {
    const response = await api.post('/Categorias', { nome, usuarioId: 0 });
    return response.data;
  },
  update: async (id, categoriaAtualizada) => {
    const response = await api.put(`/Categorias?id=${id}&categoriaAtualizada=${encodeURIComponent(categoriaAtualizada)}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/Categorias/${id}`);
    return response.data;
  },
};

// Lancamentos (Transactions) endpoints
export const transactionsService = {
  getAll: async () => {
    const response = await api.get('/Lancamentos');
    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`/Lancamentos/${id}`);
    return response.data;
  },
  create: async (valor, tipo, categoriaId, data) => {
    const response = await api.post('/Lancamentos', {
      valor,
      tipo,
      categoriaId,
      data,
      usuarioId: 0,
    });
    return response.data;
  },
  update: async (id, valor, tipo, categoriaId, data) => {
    const response = await api.put(`/Lancamentos?id=${id}`, {
      valor,
      tipo,
      categoriaId,
      data,
      usuarioId: 0,
    });
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/Lancamentos?id=${id}`);
    return response.data;
  },
};

export default api;
